export const queryParamTOArray = (param: any) => {
  if (param) {
    return Array.isArray(param) ? param : [param];
  }
  return undefined;
};
